import { FormGeneratorConfig } from "../../../utils/formGenerator";
import { FbSliderFormElement } from "../../../utils/formElements";

export const fuelLevelSettingFormConfig: FormGeneratorConfig = {
    desiredFuelLevel: {
        component: FbSliderFormElement,
        childProps: {
            label: 'Desired filling level',
            marks: true,
            showValueLabel: 'on',
            key: 'fuel_level_slider',
            min: 0,
            max: 100,
        },
    },
}
